<template>

 
      <ul class="navbar-nav align-items-lg-center ml-lg-auto">
     <li class="nav-item">
          <a
            class="nav-link nav-link-icon"
            href="https://www.facebook.com/universaltechglobal"
            target="_blank"
            rel="noopener"
            data-toggle="tooltip"
            title="Like us on Facebook"
          >
            <i class="fa fa-facebook-square fas"></i>
            <span class="nav-link-inner--text d-lg-none">Medium</span>
          </a>
        </li>  
        <li class="nav-item">
          <a
            class="nav-link nav-link-icon"
            href="https://www.linkedin.com/company/universal-tech"
            target="_blank"
            rel="noopener"
            data-toggle="tooltip"
            title="Follow us on Linkedin"
          >
            <i class="fa fa-linkedin"></i>
            <span class="nav-link-inner--text d-lg-none">Linkedin</span>
          </a>
        </li>

        <li class="nav-item d-none d-lg-block ml-lg-4">
          <a
            href="tel:888-886-4775"
            target="_blank"
            rel="noopener"
            class="btn btn-neutral btn-icon"
          >
            <span class="btn-inner--icon">
              <i class="fa fa-phone mr-2"></i>
            </span>
            <span class="nav-link-inner--text">+1 (888) 886-4775</span>
          </a>
        </li>
      </ul>

 
</template>

<script>
export default {
    
}
</script>